import React from "react";
import { TextInput, Text, View } from "react-native";
import { Mutation } from "react-apollo";
import { QueryInfiniteList, TouchableRow, RowText, ListToolbar } from "cci-component";
import { SessionQuery, getSessionInformation, findActiveOfficesByNameQuery, switchOfficeMutation } from "cci-data";

/**
 * Office selection list allows the user to change their current office (in the server side session, if authorized).
 * 
 * Props:
 * - onSelected: Function that is fired when the server has completed switching the office.
 */
// TODO Canwe use ImmutableList here instead of reimplementing features?
const SelectionList = props => (
  <SessionQuery>{({ wrapBusiness }) => (
    <Mutation
      mutation={switchOfficeMutation}
      onCompleted={props.onSelected}
    >
      {mutate => (
        <QueryInfiniteList
          queryName="findActiveOfficesByName"
          query={findActiveOfficesByNameQuery}
          variables={wrapBusiness({
            name: ""
          })}
          style={props.style}

          // Filter toolbar along the top
          filterProperty="name"
          fixedHeader={(refetch, filter, currentFilter) => <ListToolbar refresh={refetch} filter={filter} currentFilter={currentFilter} />}

          recordRenderer={({ key, index, style }, rowData) => (
            <TouchableRow
              key={key}
              style={style}
              onPress={() => 
                mutate({
                  variables: {
                    officeId: rowData.id
                  },
                  // Manually update the session information since we have all of the data to do so, no need for additional requests.
                  update: (store, { data: { switchOffice } }) => {
                    // Read the data from our cache for this query.
                    const data = store.readQuery({ query: getSessionInformation });

                    // Update local session with selected office
                    data.sessionInformation.currentOffice = rowData;

                    // Write our data back to the cache.
                    store.writeQuery({ query: getSessionInformation, data });
                  }
                })
              }
            >
              <RowText>{rowData.contact.alias || rowData.contact.companyName}</RowText>
            </TouchableRow>
          )}
        />
      )}
    </Mutation>
  )}</SessionQuery>
);

export default SelectionList;
